import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  section: {
    // padding: "6rem 2rem",
   width:'94%',
   marginLeft:'3%',
    display: "flex",
    flexDirection: "column",
    marginTop:'4%',
    marginBottom:'4%'
  },
  title: {
    fontWeight: "bold",
    marginBottom: "1rem",
    textTransform: "uppercase",
    fontSize: "0.9rem",
    letterSpacing: "1.5px",
  },
  mainHeading: {
    fontWeight: 'bold',
    fontSize: "2.6rem",
    marginBottom: "1rem",
    lineHeight: 1.2,
    fontFamily:"'Poppins',sans-serif",
  },
  subtitle: {
    fontStyle: "italic",
    color: "#666",
    marginBottom: "3rem",
    fontSize: "0.8rem",
  },
  paragraph: {
    lineHeight: 1.8,
    color: "#333",
    fontSize: "1rem",
    textAlign: "left",
  },
  highlightedLetter: {
    fontWeight: "bold",
    fontSize: "3rem",
    float: "left",
    lineHeight: 1,
    marginRight: "0.5rem",
  },
}));

const AboutSection = () => {
  const classes = useStyles();

  return (
    <Box className={classes.section}>
     
      <Grid container spacing={4} >
        <Grid item xs={12} md={5}>
        <Typography className={classes.title} variant="h6">
        What We Do
      </Typography>
      <Typography className={classes.mainHeading} variant="h3">
        We are leaders in automotive transportation
      </Typography>
      <Typography className={classes.subtitle} variant="subtitle1">
        Excellence. Transparency. Customer-Centric Approach.
      </Typography>
        </Grid>
        <Grid item xs={12} md={1}>
            </Grid>
        <Grid item xs={12} md={3}>
        <Typography className={classes.paragraph} style={{marginTop:'200px'}}>
            <span className={classes.highlightedLetter}>A</span>t Infinity Autoship, we specialize in providing seamless and reliable vehicle transportation services. Our focus is on delivering exceptional customer experiences while ensuring your vehicle reaches its destination safely and on time.
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography className={classes.paragraph}  style={{marginTop:'200px'}}>
            Using cutting-edge logistics, we offer real-time tracking and accurate estimates, ensuring you receive a service that is efficient and stress-free. Infinity Autoship is your trusted partner for all transportation needs.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutSection;
